module.exports = require("././angular-cookies.js");


//////////////////
// WEBPACK FOOTER
// angular-cookies (bower component)
// module id = 1002
// module chunks = 1